import type { ComponentProps } from 'react'

import type { VariantProps } from '@joyful/utils'
import { tv } from '@joyful/utils'

export const noneContentVariants = tv({
  base: 'text-tremor-content-subtle',

  defaultVariants: {
    size: 'inherit',
    weight: 'normal',
  },

  variants: {
    size: {
      base: 'text-base',
      inherit: {},
      sm: 'text-sm',
      xs: 'text-xs',
    },

    weight: {
      medium: 'font-medium',
      normal: {},
      semibold: 'font-semibold',
    },
  },
})

export interface NoneContentProps
  extends
    Omit<ComponentProps<'span'>, 'children' | 'className'>,
    VariantProps<typeof noneContentVariants> {
  children?: string
}

export function NoneContent({
  children = '(none)',
  size,
  weight,
  ...props
}: NoneContentProps) {
  return (
    <span {...props} className={noneContentVariants({ size, weight })}>
      {children}
    </span>
  )
}
